import React from 'react'
import moment from 'moment';
import { useTranslation } from 'react-i18next';
const RefundHistoryTable = ({ refundData, type }) => {
  const {t} = useTranslation();
    return (
      <>
        {/* <div className="table-heading">
          <h5>Credits History</h5>
        </div> */}
  
        {/* Desktop Table */}
        <div className="custom-table d-noneformobile">
          <div className="table-responsive">
            <table className="table m-0">
              <thead>
                <tr>
                  {type === "expired" && (
                    <>
                      <th>{t('Date')}</th>
                      <th className="text-center">{t('Creditexpired')}</th>
                    </>
                  )}
                  {type === "purchases" && (
                    <>
                      <th>{t('Signupforproject-t3')}</th>
                      <th>{t('Date')}</th>
                      <th className="text-center">{t('Cre102')}</th>
                      <th className="text-center">{t('Cre105')}</th>
                      <th className="text-center">{t('Gems-detailt7')}</th>
                    </>
                  )}
                  {type === "refunds" && (
                    <>
                      <th>{t('Cre7')}</th>
                      <th className="text-center">{t('Date')}</th>
                      <th className="text-center">{t('TokenRefunded')}</th>
                      <th className="text-center">{t('Creditrec')}</th>
                      <th className="text-center">{t('Creditexpiry')}</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {refundData?.map((item, index) => (
                  <tr key={item._id || index}>
                    {/* Expired */}
                    {type === "expired" && (
                      <>
                        <td>
                          {item.expiredAt
                            ? moment(item.expiredAt).format("DD MMM, YYYY")
                            : "—"}
                        </td>
                        <td className="text-center">
                          {item.creditRefunded?.toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                          })}
                        </td>
                      </>
                    )}
  
                    {/* Purchases */}
                    {type === "purchases" && (
                      <>
                        <td>
                          <div className="twice-items">
                            <img
                              src={`https://media-gems.gems.vip/logos/${item?.privateSale.toLowerCase()}.svg`}
                              alt="token"
                              className="img-fluid"
                            />
                            <h6>{item.privateSale}</h6>
                          </div>
                        </td>
                        <td>{moment(item.createdAt).format("DD MMM, YYYY")}</td>
                        <td className="text-center">
                          {item.creditConsumed?.toLocaleString(undefined, {
                            maximumFractionDigits: 6,
                          })}
                        </td>
                        <td className="text-center">
                          {item.tokenPurchased?.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}{" "}
                          {item.privateSale}
                        </td>
                        <td className="text-center">
                          ${item.roundPrice?.toFixed(4)}/{item.privateSale}
                        </td>
                      </>
                    )}
  
                    {/* Refunds */}
                    {type === "refunds" && (
                      <>
                        <td>
                          <div className="twice-items">
                            <img
                              src={`https://media-gems.gems.vip/logos/${item?.privateSale.toLowerCase()}.svg`}
                              alt="img"
                              className="img-fluid"
                            />
                            <h6>{item.privateSale}</h6>
                          </div>
                        </td>
                        <td className="text-center">
                          {moment(item.createdAt).format("DD MMM, YYYY")}
                        </td>
                        <td className="text-center">
                          {item.tokenRefunded?.toLocaleString()}{" "}
                          {item.privateSale}
                        </td>
                        <td className="text-center">
                          {item.creditRefunded?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 5,
                          })}
                        </td>
                        <td className="text-center">
                          {item.expiredAt
                            ? moment(item.expiredAt).format("DD MMM, YYYY")
                            : "—"}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Mobile View */}
        <div className="mobiletable d-none">
          {refundData?.map((item, index) => (
            <div className="innerbox" key={item._id || index}>
              <div className="innerboxhead">
                {item.privateSale && (
                  <>
                    <div className="tokenimg">
                      <img
                        src={`https://media-gems.gems.vip/logos/${item?.privateSale.toLowerCase()}.svg`}
                        alt="innertokenimg"
                        className="innertokenimg"
                      />
                    </div>
                    <p className="tokenname">{item.privateSale}</p>
                  </>
                )}
              </div>
              <div className="innerboxbody">
                <div className="inneritemmain">
                  {type === "expired" && (
                    <>
                      <div className="inneritem">
                        <p className="itempara">{t("Date")}</p>
                        <h6 className="itemhead">
                          {moment(item.expiredAt).format("DD MMM, YYYY")}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('Creditexpired')}</p>
                        <h6 className="itemhead">
                          {item.creditRefunded?.toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                          })}
                        </h6>
                      </div>
                    </>
                  )}
  
                  {type === "purchases" && (
                    <>
                      <div className="inneritem">
                        <p className="itempara">{t('Date')}</p>
                        <h6 className="itemhead">
                          {moment(item.createdAt).format("DD MMM, YYYY")}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('Cre102')}</p>
                        <h6 className="itemhead">
                          {item.creditConsumed?.toLocaleString(undefined, {
                            maximumFractionDigits: 6,
                          })}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('Cre105')}</p>
                        <h6 className="itemhead">
                          {item.tokenPurchased?.toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })}{" "}
                          {item.privateSale}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('Gems-detailt7')}</p>
                        <h6 className="itemhead">
                          ${item.roundPrice?.toFixed(4)}/{item.privateSale}
                        </h6>
                      </div>
                    </>
                  )}
  
                  {type === "refunds" && (
                    <>
                      <div className="inneritem">
                        <p className="itempara">{t('Date')}</p>
                        <h6 className="itemhead">
                          {moment(item.createdAt).format("DD MMM, YYYY")}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('TokenRefunded')}</p>
                        <h6 className="itemhead">
                          {item.tokenRefunded?.toLocaleString()}{" "}
                          {item.privateSale}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('Creditrec')}</p>
                        <h6 className="itemhead">
                          {item.creditRefunded?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 5,
                          })}
                        </h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">{t('Creditexpiry')}</p>
                        <h6 className="itemhead">
                          {item.expiredAt
                            ? moment(item.expiredAt).format("DD MMM, YYYY")
                            : "—"}
                        </h6>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };
  

export default RefundHistoryTable
